import React, { useEffect } from "react";
import "animate.css";
import ConceptTransformation from "./TransformationProject";
import PartnerShipCta from "../cta/PartnerShip";
import DonateCta from "../cta/DonateCta";

export default class ProjectComponents extends React.Component {
  render() {
    return (
      <>
        <section className="project-one">
          <div className="container">
            <div className="section-title text-center">
              {/* <span className="section-title__tagline">Our Projects</span> */}
              <h2 className="section-title__title" id="concept-transformation">Heroes of Tomorrow</h2>
            </div>
            <ConceptTransformation />
            <DonateCta />
          </div>
        </section>
      </>
    );
  }
}
